import SizeSuggestion from './SizeSuggestion';

export default SizeSuggestion;
